module.exports = __webpack_public_path__ + "media/images/bt-entrega-comum-baa4a87d6c255a6cb7d284265eb6929b.svg";